import PropTypes from 'prop-types';
import React from 'react';
import { Box, Typography } from '@material-ui/core';

// Align options
const CENTER = 'center';
const LEFT = 'left';

const PageTitle = ({ align, children }) => (
  <Box pt={3} pb={2}>
    <Typography align={align} variant="h3">
      {children}
    </Typography>
  </Box>
);

PageTitle.propTypes = {
  align: PropTypes.oneOf([CENTER, LEFT]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

PageTitle.defaultProps = {
  align: LEFT,
};

export default PageTitle;
